
export const STATUS_DISABLED = "DISABLED_SURVEY";
export const STATUS_ANSWERED = "ANSWERED_SURVEY";
export const STATUS_EXPIRED = "EXPIRED_SURVEY";


